// import React, { useEffect, useState } from "react";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Header from "./common/Header";
// import Footer from "./common/Footer";
// import MainRoutes from "./routes/MainRoutes";
// import { useLocation } from "react-router-dom";
// import ScrollButton from "./components/ScrollButton";
// // import BidFrom from "./components/biding";

// function App() {
//   const location = useLocation();
//   const [isAuthenticated, setIsAuthenticated] = useState(
//     !!sessionStorage.getItem("auth")
//   );

//   useEffect(() => {
//     setIsAuthenticated(!!sessionStorage.getItem("auth"));
//   }, []);

//   return (
//     <>
//       {/* Pass setIsAuthenticated to the Header component */}
//       {!["/booking", "/booking-complete","/adminbooking","/admin-booking","/admin-booking/","/post-ride","/post-ride/","/search-ride","/search-ride/","/post-request","/post-request/"].includes(location.pathname) && !location.pathname.startsWith("/admin-booking") && (
//         <Header
//           isAuthenticated={isAuthenticated}
//           setIsAuthenticated={setIsAuthenticated}
//         />
//       )}
//       {/* <BidFrom /> */}
//       <div className="App">
//       {/* Pass setIsAuthenticated to the MainRoutes component */}
//         <MainRoutes setIsAuthenticated={setIsAuthenticated} />
        
//         <ToastContainer />
        
//         <ScrollButton/>
//       </div>
//       {/* Include the Footer component */}
//       {!["/booking", "/booking-complete","/adminbooking","/admin-booking","/admin-booking/","/post-ride","/post-ride/","/search-ride","/search-ride/","/post-request","/post-request/"].includes(location.pathname) && !location.pathname.startsWith("/admin-booking") && (
//         <Footer />
//       )}
//     </>
//   );
// }

// export default App;


import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "./common/Header";
import Footer from "./common/Footer";
import MainRoutes from "./routes/MainRoutes";
import { useLocation } from "react-router-dom";
import ScrollButton from "./components/ScrollButton";

function App() {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!sessionStorage.getItem("auth")
  );

  useEffect(() => {
    setIsAuthenticated(!!sessionStorage.getItem("auth"));
  }, []);

  const hideLayoutRoutes = [
    "/booking",
    "/booking-complete",
    "/adminbooking",
    "/admin-booking",
    "/post-ride",
    "/search-ride",
    "/post-request",
  ];

  const shouldHideLayout =
    hideLayoutRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/admin-booking");

  return (
    <>
  {!shouldHideLayout && (
    <Header
      isAuthenticated={isAuthenticated}
      setIsAuthenticated={setIsAuthenticated}
    />
  )}
  




  <MainRoutes setIsAuthenticated={setIsAuthenticated} />

  <ToastContainer />

  {!shouldHideLayout && <ScrollButton />}

  {!shouldHideLayout && <Footer />}
</>
  
);
}

export default App;
